import { render, staticRenderFns } from "./createCreditNoteButton.vue?vue&type=template&id=1b2d1d8e"
import script from "./createCreditNoteButton.vue?vue&type=script&lang=js"
export * from "./createCreditNoteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports